/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseImagePageBlockType = {
    Icon: 'ICON',
    Image: 'IMAGE'
} as const;
export type DatabaseImagePageBlockType = typeof DatabaseImagePageBlockType[keyof typeof DatabaseImagePageBlockType];


export function DatabaseImagePageBlockTypeFromJSON(json: any): DatabaseImagePageBlockType {
    return DatabaseImagePageBlockTypeFromJSONTyped(json, false);
}

export function DatabaseImagePageBlockTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseImagePageBlockType {
    return json as DatabaseImagePageBlockType;
}

export function DatabaseImagePageBlockTypeToJSON(value?: DatabaseImagePageBlockType | null): any {
    return value as any;
}

